var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43969 9.30829C6.28425 9.09855 7.76253 7.60179 7.97291 5.7294C8.24903 3.28118 6.37441 1.19715 4.02457 1.17046V0.0721905C4.02457 0.0111758 3.94943 -0.0212383 3.89872 0.0168959L1.67096 1.67764C1.63339 1.70624 1.63339 1.76154 1.67096 1.79014L3.89872 3.45088C3.94943 3.48901 4.02457 3.45469 4.02457 3.39559V2.29923C5.67566 2.32592 6.99803 3.75214 6.88533 5.45674C6.78953 6.923 5.61179 8.11278 4.16732 8.20621C2.63645 8.30536 1.33473 7.19566 1.10181 5.72749C1.05861 5.45483 0.823815 5.25653 0.553329 5.25653C0.2171 5.25653 -0.0458728 5.5597 0.00672173 5.89719C0.333559 7.98885 2.23635 9.55807 4.43969 9.30829Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.710dc796fbd64e3f03d52da02e3fdad1.svg";
export { ForwardRef as ReactComponent };